"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _constant2 = require("../../constant");

var _default = {
  PropTypes: {
    theme: _propTypes.string,
    viewport: (0, _propTypes.oneOf)(Object.values(_constant2.DEVICE_TYPE)),
    calendarModalOpen: _propTypes.bool,
    callbackOpenCalendarModal: _propTypes.func,
    calendarProps: _propTypes.object,
    maxDays: _propTypes.number
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    viewport: _constant2.DEVICE_TYPE.DESKTOP,
    maxDays: 510
  }
};
exports.default = _default;